/**
 * Subscription / dev test panel (TestSubscriptionUpgrade).
 * Enable via REACT_APP_ENABLE_TEST_MODE, ?test_mode=true, or localStorage.
 */

const STORAGE_KEY = 'glowlens_test_mode';

function readUrlTestMode(): boolean {
  if (typeof window === 'undefined' || !window.location) return false;
  const v = String(new URLSearchParams(window.location.search).get('test_mode') || '').toLowerCase();
  return ['true', '1', 'yes'].includes(v);
}

function readStorageTestMode(): boolean {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

/** True when the Test Mode subscription panel should render. */
export function isSubscriptionTestModeEnabled(): boolean {
  if (typeof process !== 'undefined' && process.env) {
    if (process.env.NODE_ENV === 'development') return true;
    if (process.env.REACT_APP_ENABLE_TEST_MODE === 'true') return true;
  }
  return readUrlTestMode() || readStorageTestMode();
}

/** Turn on test mode and persist across reloads (also used by ?test_mode=true). */
export function activateSubscriptionTestMode(): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      /* ignore */
    }
  }
  if (typeof console !== 'undefined') {
    console.log('[GlowLens] Test mode activated (subscription panel + persisted)');
  }
}

export function deactivateSubscriptionTestMode(): void {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }
}

/** Call once on app load — persists ?test_mode=true to localStorage. */
export function syncSubscriptionTestModeFromUrl(): void {
  if (readUrlTestMode()) {
    activateSubscriptionTestMode();
  } else if (
    typeof process !== 'undefined' &&
    process.env?.REACT_APP_ENABLE_TEST_MODE === 'true'
  ) {
    activateSubscriptionTestMode();
  }
}

if (typeof window !== 'undefined') {
  (window as Window & { glowlensActivateTestMode?: () => void }).glowlensActivateTestMode =
    () => {
      activateSubscriptionTestMode();
      try {
        const { enableTestingMode } = require('./scanAccuracyTesting');
        enableTestingMode();
      } catch {
        /* scanAccuracyTesting optional at runtime */
      }
      window.location.reload();
    };
}
